<section class="problema" appReveal>
  <span class="etiqueta">{{ 'problema.etiqueta' | translate }}</span>
  <h2>{{ 'problema.titulo' | translate }}</h2>
  <p>{{ 'problema.texto' | translate }}</p>
</section>
